import Card from '@mui/material/Card';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import { DashboardContent } from 'src/layouts/dashboard/content';

import { Iconify } from 'src/components/iconify';
import { CustomBreadcrumbs } from 'src/components/custom-breadcrumbs';

// ----------------------------------------------------------------------
// Placeholder dos módulos do Portal SN ainda não construídos. Cada entrada nova
// do menu real (ver nav-config-dashboard.tsx) aponta pra cá até o módulo
// correspondente ser implementado — assim a estrutura de navegação (IA) do
// portal SN fica navegável desde já, sem telas mock do produto errado (SGT).

export default function EmConstrucaoPage({ titulo }: { titulo: string }) {
  return (
    <DashboardContent>
      <CustomBreadcrumbs heading={titulo} links={[{ name: titulo }]} sx={{ mb: { xs: 2, md: 3 } }} />
      <Card sx={{ p: 6 }}>
        <Stack spacing={2} alignItems="center" sx={{ textAlign: 'center', color: 'text.secondary' }}>
          <Iconify icon="solar:settings-bold-duotone" width={48} />
          <Typography variant="h6">Módulo em construção</Typography>
          <Typography variant="body2" sx={{ maxWidth: 420 }}>
            {titulo} faz parte do Portal do Contribuinte do Simples Nacional e será
            implementado nas próximas etapas do porte.
          </Typography>
        </Stack>
      </Card>
    </DashboardContent>
  );
}
